import { skipToken } from '@reduxjs/toolkit/query'

import { useGetTransfersQuery } from '../../../payments/data/transfersApi'

interface UseAppointmentChargeCheckParams {
  appointmentId: number | null | undefined
  clientId: string | null
  providerId: string
  enabled: boolean
}

interface UseAppointmentChargeCheckResult {
  hasCharge: boolean
  isLoading: boolean
}

export const useAppointmentChargeCheck = ({
  appointmentId,
  clientId,
  providerId,
  enabled,
}: UseAppointmentChargeCheckParams): UseAppointmentChargeCheckResult => {
  const { data, isFetching, isUninitialized } = useGetTransfersQuery(
    enabled && clientId && appointmentId
      ? {
          provider_id: providerId,
          patient_id: clientId,
          appointment_id: appointmentId,
          showAlert: false,
        }
      : skipToken,
    { refetchOnMountOrArgChange: true },
  )

  const charges = (data?.data ?? []).filter((charge) => charge?.appointment_id === appointmentId)

  return {
    hasCharge: charges.length > 0,
    isLoading: enabled && (isFetching || isUninitialized),
  }
}
